var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMvp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 70.1846,
    height: 34.1695,
    viewBox: "0 0 70.1846 34.1695",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.0997 1.57721C61.6643 1.57721 68.6075 8.52044 68.6075 17.085C68.6073 25.6495 61.6642 32.5919 53.0997 32.5919H17.085C8.52054 32.5919 1.57737 25.6495 1.57721 17.085C1.57721 8.52044 8.52044 1.57721 17.085 1.57721H53.0997Z",
    fill: "url(#paint0_linear_822_8983)",
    stroke: "url(#paint1_linear_822_8983)",
    strokeWidth: 3.15436
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: 4.28689,
    y: 4.28689,
    width: 61.6107,
    height: 25.5956,
    rx: 12.7978,
    fill: "url(#paint2_linear_822_8983)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 22",
    filter: "url(#filter0_f_822_8983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 5",
    opacity: 0.2,
    d: "M19.4887 26.4961C19.6732 26.4156 19.8529 26.6183 19.7508 26.7919V26.7919C19.7052 26.8695 19.7148 26.9677 19.7745 27.035V27.035C19.908 27.1857 19.7707 27.4192 19.5741 27.3758V27.3758C19.4862 27.3564 19.3958 27.3958 19.3502 27.4734V27.4734C19.2482 27.6469 18.9837 27.5885 18.9642 27.3882V27.3882C18.9555 27.2986 18.8901 27.2247 18.8022 27.2053V27.2053C18.6056 27.1619 18.5794 26.8923 18.764 26.8119V26.8119C18.8465 26.7759 18.8965 26.6909 18.8878 26.6013V26.6013C18.8683 26.401 19.1166 26.2927 19.2501 26.4434V26.4434C19.3098 26.5108 19.4061 26.532 19.4887 26.4961V26.4961Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 12",
    opacity: 0.2,
    d: "M8.37999 20.0823C8.53596 20.2096 8.43795 20.4621 8.23696 20.4508V20.4508C8.14708 20.4458 8.06416 20.4992 8.03159 20.5831V20.5831C7.95875 20.7708 7.68832 20.7556 7.63694 20.561V20.561C7.61396 20.4739 7.53755 20.4116 7.44766 20.4065V20.4065C7.24667 20.3952 7.17754 20.1333 7.34678 20.0243V20.0243C7.42246 19.9756 7.45815 19.8836 7.43517 19.7966V19.7966C7.38379 19.6019 7.6115 19.4553 7.76748 19.5825V19.5825C7.83723 19.6395 7.9357 19.645 8.01138 19.5962V19.5962C8.18062 19.4872 8.39048 19.6585 8.31764 19.8461V19.8461C8.28506 19.9301 8.31024 20.0254 8.37999 20.0823V20.0823Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 13",
    opacity: 0.2,
    d: "M31.5037 22.6344C31.7029 22.6637 31.7483 22.9307 31.5699 23.0241V23.0241C31.4902 23.0659 31.4464 23.1542 31.4615 23.243V23.243C31.4952 23.4415 31.2553 23.5671 31.1114 23.4264V23.4264C31.047 23.3635 30.9494 23.3492 30.8697 23.3909V23.3909C30.6913 23.4843 30.4977 23.295 30.587 23.1146V23.1146C30.627 23.0339 30.6105 22.9367 30.5461 22.8738V22.8738C30.4021 22.733 30.5224 22.4903 30.7215 22.5196V22.5196C30.8106 22.5326 30.898 22.4869 30.9379 22.4062V22.4062C31.0273 22.2258 31.2953 22.2652 31.329 22.4636V22.4636C31.3441 22.5524 31.4146 22.6213 31.5037 22.6344V22.6344Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 14",
    opacity: 0.2,
    d: "M43.4701 26.0983C43.6279 25.9734 43.8535 26.1234 43.7992 26.3172V26.3172C43.775 26.4039 43.8093 26.4964 43.8843 26.5462V26.5462C44.0519 26.6577 43.979 26.9186 43.7778 26.9269V26.9269C43.6879 26.9306 43.6105 26.9919 43.5863 27.0786V27.0786C43.5321 27.2724 43.2614 27.2836 43.1914 27.0949V27.0949C43.16 27.0105 43.0779 26.9559 42.988 26.9596V26.9596C42.7868 26.968 42.6925 26.7141 42.8503 26.5891V26.5891C42.9209 26.5332 42.9475 26.4382 42.9161 26.3538V26.3538C42.8461 26.1651 43.0584 25.997 43.226 26.1084V26.1084C43.301 26.1583 43.3995 26.1542 43.4701 26.0983V26.0983Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 15",
    opacity: 0.2,
    d: "M57.6404 25.2074C57.8406 25.2278 57.8977 25.4926 57.7237 25.5938V25.5938C57.6459 25.639 57.6061 25.7292 57.625 25.8172V25.8172C57.6675 26.014 57.4333 26.1502 57.2833 26.0159V26.0159C57.2162 25.9559 57.1181 25.9459 57.0403 25.9911V25.9911C56.8663 26.0923 56.6644 25.9117 56.7457 25.7275V25.7275C56.7821 25.6452 56.7613 25.5488 56.6942 25.4887V25.4887C56.5442 25.3545 56.6536 25.1067 56.8539 25.1272V25.1272C56.9435 25.1363 57.0287 25.0867 57.0651 25.0044V25.0044C57.1464 24.8202 57.4159 24.8477 57.4583 25.0445V25.0445C57.4773 25.1325 57.5508 25.1982 57.6404 25.2074V25.2074Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 16",
    opacity: 0.2,
    d: "M60.0328 19.6661C60.2298 19.6247 60.3647 19.8595 60.2297 20.0088V20.0088C60.1693 20.0756 60.1588 20.1737 60.2037 20.2517V20.2517C60.304 20.4263 60.1223 20.6272 59.9386 20.5449V20.5449C59.8564 20.5082 59.7599 20.5285 59.6995 20.5953V20.5953C59.5645 20.7446 59.3173 20.6339 59.3388 20.4337V20.4337C59.3484 20.3442 59.2992 20.2587 59.2171 20.2219V20.2219C59.0333 20.1397 59.0622 19.8704 59.2592 19.8289V19.8289C59.3473 19.8104 59.4134 19.7372 59.423 19.6477V19.6477C59.4445 19.4475 59.7095 19.3918 59.8098 19.5663V19.5663C59.8547 19.6444 59.9447 19.6847 60.0328 19.6661V19.6661Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 6",
    opacity: 0.5,
    d: "M18.3417 7.56818C18.5106 7.67782 18.4405 7.93945 18.2394 7.94998V7.94998C18.1495 7.9547 18.0729 8.01676 18.0496 8.10372V8.10372C17.9975 8.29817 17.727 8.31235 17.6548 8.12441V8.12441C17.6226 8.04036 17.5399 7.98665 17.45 7.99136V7.99136C17.2489 8.00189 17.1519 7.74903 17.3083 7.62234V7.62234C17.3783 7.56568 17.4038 7.47042 17.3715 7.38637V7.38637C17.2994 7.19843 17.5099 7.02798 17.6787 7.13762V7.13762C17.7542 7.18665 17.8527 7.18149 17.9227 7.12483V7.12483C18.0791 6.99815 18.3063 7.14567 18.2542 7.34011V7.34011C18.2309 7.42707 18.2662 7.51915 18.3417 7.56818V7.56818Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 17",
    opacity: 0.5,
    d: "M20.7386 13.2835C20.9121 13.1815 21.1149 13.361 21.0345 13.5456V13.5456C20.9986 13.6282 21.0199 13.7245 21.0873 13.7841V13.7841C21.238 13.9176 21.1298 14.1659 20.9295 14.1465V14.1465C20.8399 14.1379 20.7549 14.1879 20.7189 14.2704V14.2704C20.6385 14.455 20.3689 14.4289 20.3255 14.2323V14.2323C20.306 14.1444 20.2322 14.079 20.1426 14.0704V14.0704C19.9422 14.051 19.8837 13.7865 20.0572 13.6844V13.6844C20.1348 13.6388 20.1742 13.5483 20.1548 13.4604V13.4604C20.1113 13.2639 20.3448 13.1265 20.4955 13.26V13.26C20.5629 13.3197 20.661 13.3292 20.7386 13.2835V13.2835Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 18",
    opacity: 0.5,
    d: "M9.90399 12.8261C10.1007 12.8686 10.1281 13.1381 9.94387 13.2193V13.2193C9.86149 13.2556 9.81187 13.3409 9.82096 13.4304V13.4304C9.84127 13.6307 9.59343 13.74 9.45927 13.5899V13.5899C9.39928 13.5228 9.30288 13.5019 9.2205 13.5382V13.5382C9.0363 13.6194 8.8558 13.4175 8.95709 13.2435V13.2435C9.00239 13.1657 8.99243 13.0676 8.93244 13.0005V13.0005C8.79828 12.8504 8.93457 12.6163 9.13132 12.6589V12.6589C9.21931 12.6779 9.30956 12.6381 9.35485 12.5603V12.5603C9.45614 12.3864 9.72087 12.4436 9.74119 12.6439V12.6439C9.75027 12.7335 9.816 12.807 9.90399 12.8261V12.8261Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 7",
    opacity: 0.5,
    d: "M31.0535 6.77612C31.2476 6.72281 31.3966 6.94905 31.2708 7.10628V7.10628C31.2146 7.1766 31.2101 7.27512 31.2596 7.35032V7.35032C31.3703 7.51846 31.2011 7.73001 31.0127 7.65904V7.65904C30.9285 7.6273 30.8334 7.65342 30.7772 7.72373V7.72373C30.6514 7.88096 30.398 7.78547 30.4073 7.58438V7.58438C30.4114 7.49444 30.3572 7.41207 30.2729 7.38033V7.38033C30.0846 7.30935 30.0971 7.03878 30.2912 6.98547V6.98547C30.378 6.96163 30.4396 6.8846 30.4437 6.79467V6.79467C30.453 6.59358 30.7142 6.52185 30.8249 6.69V6.69C30.8744 6.76519 30.9667 6.79997 31.0535 6.77612V6.77612Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 8",
    opacity: 0.5,
    d: "M37.771 12.4265C37.9575 12.5022 37.9381 12.7724 37.7427 12.8207V12.8207C37.6553 12.8424 37.5917 12.9178 37.5853 13.0076V13.0076C37.5709 13.2084 37.3079 13.2734 37.2016 13.1025V13.1025C37.154 13.026 37.0626 12.9889 36.9752 13.0105V13.0105C36.7798 13.0589 36.6367 12.8289 36.7664 12.6749V12.6749C36.8244 12.6061 36.8315 12.5077 36.7839 12.4313V12.4313C36.6775 12.2604 36.852 12.0532 37.0385 12.129V12.129C37.1219 12.1628 37.2177 12.1392 37.2757 12.0703V12.0703C37.4054 11.9163 37.6563 12.0183 37.6419 12.2191V12.2191C37.6355 12.3089 37.6876 12.3926 37.771 12.4265V12.4265Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 9",
    opacity: 0.5,
    d: "M43.2367 6.94787C43.4377 6.95878 43.5073 7.22053 43.3383 7.32986V7.32986C43.2627 7.37875 43.2272 7.47076 43.2503 7.55776V7.55776C43.3021 7.75231 43.0747 7.89941 42.9184 7.77243V7.77243C42.8486 7.71564 42.7501 7.7103 42.6745 7.75919V7.75919C42.5055 7.86852 42.2953 7.69767 42.3678 7.50987V7.50987C42.4002 7.42588 42.3749 7.33057 42.305 7.27379V7.27379C42.1488 7.14681 42.2463 6.89412 42.4473 6.90503V6.90503C42.5372 6.90991 42.62 6.85635 42.6525 6.77236V6.77236C42.7249 6.58456 42.9954 6.59923 43.0472 6.79378V6.79378C43.0703 6.88078 43.1468 6.94299 43.2367 6.94787V6.94787Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 10",
    opacity: 0.5,
    d: "M50.9477 6.67976C50.8968 6.485 51.1248 6.33886 51.2805 6.46649V6.46649C51.3501 6.52356 51.4486 6.52932 51.5244 6.48074V6.48074C51.6939 6.37212 51.9033 6.54385 51.8301 6.73134V6.73134C51.7973 6.8152 51.8222 6.91061 51.8919 6.96769V6.96769C52.0475 7.09532 51.949 7.34759 51.748 7.33585V7.33585C51.6581 7.33059 51.5751 7.38381 51.5423 7.46766V7.46766C51.469 7.65516 51.1986 7.63935 51.1477 7.44459V7.44459C51.1249 7.35749 51.0487 7.29497 50.9588 7.28971V7.28971C50.7578 7.27796 50.6893 7.01592 50.8588 6.9073V6.9073C50.9346 6.85872 50.9705 6.76686 50.9477 6.67976V6.67976Z",
    fill: "#FFECAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 11",
    opacity: 0.5,
    d: "M59.1244 10.718C59.2831 10.5941 59.5076 10.7457 59.452 10.9392V10.9392C59.4272 11.0257 59.4608 11.1184 59.5355 11.1687V11.1687C59.7023 11.2814 59.6276 11.5417 59.4264 11.5487V11.5487C59.3364 11.5518 59.2587 11.6125 59.2338 11.699V11.699C59.1783 11.8925 58.9076 11.9018 58.8388 11.7127V11.7127C58.808 11.628 58.7263 11.5729 58.6363 11.576V11.576C58.4351 11.5829 58.3426 11.3284 58.5012 11.2045V11.2045C58.5722 11.1491 58.5994 11.0543 58.5687 10.9697V10.9697C58.4999 10.7805 58.7134 10.6138 58.8802 10.7264V10.7264C58.9549 10.7768 59.0534 10.7734 59.1244 10.718V10.718Z",
    fill: "#FFECAB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MVP",
    filter: "url(#filter1_dd_822_8983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7694 24.3901C46.0725 24.3901 45.5076 23.8252 45.5076 23.1283V11.3586C45.5076 10.6617 46.0725 10.0968 46.7694 10.0968H52.3806C53.4618 10.0968 54.3809 10.286 55.1378 10.6645C55.8947 11.0294 56.4692 11.5633 56.8611 12.2662C57.2666 12.9555 57.4694 13.7935 57.4694 14.7801C57.4694 15.7398 57.2666 16.5778 56.8611 17.2941C56.4692 17.997 55.8947 18.5376 55.1378 18.9161C54.3809 19.281 53.4618 19.4635 52.3806 19.4635H50.4998C49.803 19.4635 49.2381 20.0284 49.2381 20.7252V23.1283C49.2381 23.8252 48.6732 24.3901 47.9763 24.3901H46.7694ZM49.2381 15.3431C49.2381 16.0399 49.803 16.6048 50.4998 16.6048H51.7318C52.4346 16.6048 52.9753 16.4561 53.3537 16.1588C53.7322 15.8479 53.9214 15.3884 53.9214 14.7801C53.9214 14.1584 53.7322 13.6989 53.3537 13.4015C52.9753 13.1041 52.4346 12.9555 51.7318 12.9555H50.4998C49.803 12.9555 49.2381 13.5204 49.2381 14.2172V15.3431Z",
    fill: "url(#paint3_linear_822_8983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7694 24.3901C46.0725 24.3901 45.5076 23.8252 45.5076 23.1283V11.3586C45.5076 10.6617 46.0725 10.0968 46.7694 10.0968H52.3806C53.4618 10.0968 54.3809 10.286 55.1378 10.6645C55.8947 11.0294 56.4692 11.5633 56.8611 12.2662C57.2666 12.9555 57.4694 13.7935 57.4694 14.7801C57.4694 15.7398 57.2666 16.5778 56.8611 17.2941C56.4692 17.997 55.8947 18.5376 55.1378 18.9161C54.3809 19.281 53.4618 19.4635 52.3806 19.4635H50.4998C49.803 19.4635 49.2381 20.0284 49.2381 20.7252V23.1283C49.2381 23.8252 48.6732 24.3901 47.9763 24.3901H46.7694ZM49.2381 15.3431C49.2381 16.0399 49.803 16.6048 50.4998 16.6048H51.7318C52.4346 16.6048 52.9753 16.4561 53.3537 16.1588C53.7322 15.8479 53.9214 15.3884 53.9214 14.7801C53.9214 14.1584 53.7322 13.6989 53.3537 13.4015C52.9753 13.1041 52.4346 12.9555 51.7318 12.9555H50.4998C49.803 12.9555 49.2381 13.5204 49.2381 14.2172V15.3431Z",
    fill: "url(#paint4_radial_822_8983)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.172 24.3901C35.6775 24.3901 35.2286 24.1012 35.0237 23.6512L29.6647 11.8814C29.2843 11.0459 29.895 10.0968 30.813 10.0968H31.9955C32.4994 10.0968 32.955 10.3966 33.1543 10.8594L37.2643 20.4018C37.3705 20.6484 37.1897 20.9232 36.9212 20.9232C36.6527 20.9232 36.4719 20.6484 36.5781 20.4018L40.6881 10.8594C40.8875 10.3966 41.343 10.0968 41.8469 10.0968H42.885C43.8036 10.0968 44.4144 11.0471 44.0327 11.8828L38.657 23.6525C38.4518 24.1019 38.0033 24.3901 37.5093 24.3901H36.172Z",
    fill: "url(#paint5_linear_822_8983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.172 24.3901C35.6775 24.3901 35.2286 24.1012 35.0237 23.6512L29.6647 11.8814C29.2843 11.0459 29.895 10.0968 30.813 10.0968H31.9955C32.4994 10.0968 32.955 10.3966 33.1543 10.8594L37.2643 20.4018C37.3705 20.6484 37.1897 20.9232 36.9212 20.9232C36.6527 20.9232 36.4719 20.6484 36.5781 20.4018L40.6881 10.8594C40.8875 10.3966 41.343 10.0968 41.8469 10.0968H42.885C43.8036 10.0968 44.4144 11.0471 44.0327 11.8828L38.657 23.6525C38.4518 24.1019 38.0033 24.3901 37.5093 24.3901H36.172Z",
    fill: "url(#paint6_radial_822_8983)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1554 24.3901C13.4585 24.3901 12.8936 23.8252 12.8936 23.1283V11.3586C12.8936 10.6617 13.4585 10.0968 14.1554 10.0968H15.2552C15.7123 10.0968 16.1337 10.3441 16.3567 10.7432L20.749 18.606C20.8266 18.7449 20.7262 18.9161 20.5671 18.9161C20.4081 18.9161 20.3076 18.7453 20.3849 18.6063L24.7583 10.7452C24.9809 10.345 25.4029 10.0968 25.8609 10.0968H26.8781C27.5749 10.0968 28.1398 10.6617 28.1398 11.3586V23.1283C28.1398 23.8252 27.5749 24.3901 26.8781 24.3901H26.036C25.3392 24.3901 24.7743 23.8252 24.7743 23.1283V16.051C24.7743 15.965 24.8441 15.8952 24.9301 15.8952C25.0501 15.8952 25.125 16.0251 25.065 16.129L21.8745 21.6511C21.649 22.0412 21.2326 22.2816 20.782 22.2816H20.2121C19.7608 22.2816 19.3439 22.0406 19.1187 21.6496L15.9403 16.131C15.8747 16.0171 15.9569 15.8749 16.0883 15.8749C16.1827 15.8749 16.2592 15.9514 16.2592 16.0458V23.1283C16.2592 23.8252 15.6943 24.3901 14.9974 24.3901H14.1554Z",
    fill: "url(#paint7_linear_822_8983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1554 24.3901C13.4585 24.3901 12.8936 23.8252 12.8936 23.1283V11.3586C12.8936 10.6617 13.4585 10.0968 14.1554 10.0968H15.2552C15.7123 10.0968 16.1337 10.3441 16.3567 10.7432L20.749 18.606C20.8266 18.7449 20.7262 18.9161 20.5671 18.9161C20.4081 18.9161 20.3076 18.7453 20.3849 18.6063L24.7583 10.7452C24.9809 10.345 25.4029 10.0968 25.8609 10.0968H26.8781C27.5749 10.0968 28.1398 10.6617 28.1398 11.3586V23.1283C28.1398 23.8252 27.5749 24.3901 26.8781 24.3901H26.036C25.3392 24.3901 24.7743 23.8252 24.7743 23.1283V16.051C24.7743 15.965 24.8441 15.8952 24.9301 15.8952C25.0501 15.8952 25.125 16.0251 25.065 16.129L21.8745 21.6511C21.649 22.0412 21.2326 22.2816 20.782 22.2816H20.2121C19.7608 22.2816 19.3439 22.0406 19.1187 21.6496L15.9403 16.131C15.8747 16.0171 15.9569 15.8749 16.0883 15.8749C16.1827 15.8749 16.2592 15.9514 16.2592 16.0458V23.1283C16.2592 23.8252 15.6943 24.3901 14.9974 24.3901H14.1554Z",
    fill: "url(#paint8_radial_822_8983)",
    fillOpacity: 0.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_822_8983",
    x: 4.72773,
    y: 3.89501,
    width: 58.08,
    height: 26.2046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26174,
    result: "effect1_foregroundBlur_822_8983"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_822_8983",
    x: 12.8936,
    y: 9.46595,
    width: 44.5757,
    height: 16.1859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.26174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_822_8983"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.630872
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.74902 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_822_8983",
    result: "effect2_dropShadow_822_8983"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_822_8983",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_822_8983",
    x1: 35.0923,
    y1: 3.15436,
    x2: 35.0923,
    y2: 31.0151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_822_8983",
    x1: 35.0923,
    y1: 3.15436,
    x2: 35.0923,
    y2: 31.0151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3B259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_822_8983",
    x1: 34.8241,
    y1: 4.28689,
    x2: 34.8241,
    y2: 29.8825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5DE7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F4D683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F4CA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_822_8983",
    x1: 51.4885,
    y1: 10.0968,
    x2: 51.4885,
    y2: 24.3901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_822_8983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.68028 -13.8171 1.18889 5.59254 49.1242 24.1066)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_822_8983",
    x1: 36.8503,
    y1: 10.0968,
    x2: 36.8503,
    y2: 24.3901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_822_8983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.25888 -13.8171 1.58989 5.59254 33.6885 24.1066)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_822_8983",
    x1: 20.5167,
    y1: 10.0968,
    x2: 20.5167,
    y2: 24.3901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_822_8983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.96537 -13.8171 1.51533 5.59254 17.5033 24.1066)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMvp);
export default __webpack_public_path__ + "static/media/logo_mvp.ab2b6bca7231d5990346032ccf000c32.svg";
export { ForwardRef as ReactComponent };